import React, { Component } from "react";
import _ from "lodash";

import { getItemPresentation, getItemMeatPresentation, groupItemsByStationWithoutZeroQty } from "../../utils/Helpers";

import SearchInventoryBar from "../generics/SearchInventoryBar";

const getInventoriesFromShipment = (shipment, itemId, grade) => {
  let inventories = [];
  if (!shipment.shipment) {
    return inventories;
  }
  inventories = _.flatMap(
    shipment.shipment.packages.map((pkg) => {
      return pkg.items.filter((inventory) => {
        const isSameItem = inventory.item.id === itemId;
        if (grade) {
          return isSameItem && inventory.extra_info.grade && inventory.extra_info.grade.grade === grade;
        }
        return isSameItem;
      });
    })
  );

  if (inventories.length > 0 && inventories[0].item.is_barcode_item) {
    inventories = _.orderBy(inventories, ['brand.brand_name'], ['asc']);
  }

  return inventories;
};

const Item = ({ item, backOrder, inventories, isEvenRow, receivedInventories, receivedErrors, onReceivedInventoryChanged }) => {
  const presentation = getItemPresentation(item.item);
  const rowClass = isEvenRow ? "table-row-even" : "table-row-odd";
  return (
    <tr className={rowClass}>
      <td className="p-0">
        <table className="w-100">
          <tbody>
            <tr>
              <td colSpan="2">
                {item ? item.name : ""} {item.grade !== null ? `(Grade: ${item.grade})` : ""}
              </td>
            </tr>
            <tr>
              <td className="border-0">Qty: {item.amount}</td>
              <td className="border-0">
                <b>Pending: </b>
                {backOrder ? backOrder.back_order_amount : "0"}
              </td>
            </tr>
          </tbody>
        </table>
      </td>
      <td className="hidden-xs-down">{presentation ? presentation : getItemMeatPresentation(item.item, item.presentation)}</td>
      <td colSpan="2" className="p-0">
        <table className="w-100 table-striped table-custom-dark">
          <tbody>
            {inventories.map((inventory) => {
              const hasError = receivedErrors.indexOf(inventory.id) !== -1;
              return (
                <tr key={inventory.id} className={`${hasError ? "error-row" : ""}`}>
                  <td>{inventory.id}{item.item.is_barcode_item && ` (${inventory.brand.brand_name})`}</td>
                  <td>
                    <input
                      type="checkbox"
                      checked={receivedInventories[inventory.id]}
                      onChange={(event) => {
                        onReceivedInventoryChanged(inventory.id, event.target.checked);
                      }}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </td>
    </tr>
  );
};

const StationHeader = ({ station }) => {
  return (
    <tr className="table-section-header">
      <td colSpan="4">{station}</td>
    </tr>
  );
};

export default class OrderInventoryDetail extends Component {
  render() {
    const { order, backOrder, shipment, receivedInventories, receivedErrors, onReceivedInventoryChanged } = this.props;
    const itemsByStation = groupItemsByStationWithoutZeroQty(order.items);
    return (
      <div className="card">
        <SearchInventoryBar
          forOrderReceived
          goToInventory={(id, format, times, from_scanner) => {
            onReceivedInventoryChanged(id, true, null, null, format, times, from_scanner);
          }}
          multiple_times_allowed={true}
          barcode_scanner={true}
          autoFocus
        />
        <div className="card-block p-0">
          <table className="table table-bordered table-order-station datatable mb-0">
            <thead>
              <tr>
                <th>Item</th>
                <th className="hidden-xs-down">Presentation</th>
                <th colSpan="2"></th>
              </tr>
            </thead>
            {Object.keys(itemsByStation).map((station) => {
              return (
                <tbody key={station}>
                  <StationHeader station={station} key={station} />
                  {itemsByStation[station].map((item, index) => {
                    const itemBackOrder = backOrder.detail.find((boItem) => {
                      return boItem.id === item.id;
                    });
                    const itemInventories = getInventoriesFromShipment(shipment, item.item.id, item.grade);
                    return (
                      <Item
                        key={item.id}
                        item={item}
                        backOrder={itemBackOrder}
                        inventories={itemInventories}
                        isEvenRow={index % 2 === 0}
                        receivedInventories={receivedInventories}
                        receivedErrors={receivedErrors}
                        onReceivedInventoryChanged={onReceivedInventoryChanged}
                      />
                    );
                  })}
                </tbody>
              );
            })}
          </table>
        </div>
      </div>
    );
  }
}
